/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-11 15:12:11
 */
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { get, isEmpty } from 'lodash';

import { DictionaryService } from '@ithinkdt/shared/dict';
import { ControlValueAccessorService } from '../../control-value-accessor.service';
import { FormSearchService } from './../../fetch/form-fetch.service';

import { DictConf } from '../../form.interface';
import monitor from '../../monitor';
@Component({
  selector: 'dt-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponent),
      multi: true,
    },
  ],
})
export class FormSelectComponent extends ControlValueAccessorService implements OnInit, OnDestroy {
  @ViewChild('treedom', { static: false }) treedom: any;
  dictConf: DictConf;
  @Input() placeholder = 'è¯·éæ©';
  @Input() searchParmas = '';
  @Input() itemClass = '';
  @Input() itemStyle = {};
  @Input() size = 'default';
  @Input() options: object[] = [];
  @Input()
  set dictCode(code: string) {
    this.setOptions(code);
  }
  @Input() set clear(_clear) {
    if (_clear !== undefined) {
      this.allowClear = _clear;
    }
  }
  allowClear = true;
  // å¤é
  // æ¯å¦å±å¼å¨é¨æ¾ç¤º
  @Input() expandAll = false;
  // æå¤æ¾ç¤ºæ°é
  @Input() maxTagCount = 100;
  @Input() requsetTypeIsForm: any;
  @Input() prop: string;
  @Input() type = 'select';
  // èªå®ä¹æ¥å£æ¶çåæ°
  @Input() params: any;
  isInit = false;
  iTime;
  /**
   * [
   * {
   *  prop: 'name',
   *  show: ['key'],
   *  showType:"" // or || and
   *  value: [],
   *  fetch: {
   *    // {è½¬æ¢çkeyï¼[æ¹å¯¹è±¡çåæ°æ®çkey]}
   *    params: {key:tagertKey} || "key"
   *  }
   * }
   * ]
   */
  @Input() associate: any; // å³èçæä½
  // èªå®ä¹çæ¥å£
  urlCopy = '';
  isLoading = false;
  @Input() set url(str: string) {
    this.urlCopy = str;
    this.setUserDefineOptions(str, this.requsetTypeIsForm);
  }
  @Input() parse: { [propName: string]: string } = {};

  @Output() valueChange = new EventEmitter<any>();
  @Output() selectValueChange = new EventEmitter<any>();
  @Output() selectClick = new EventEmitter<any>();
  constructor(
    private settingsSrv: SettingsService,
    private formSearchSrv: FormSearchService,
    private dictSrv: DictionaryService
  ) {
    super();
    this.dictConf = this.settingsSrv.userConfig['pages'].dictConf || {};
  }
  writeValue(value) {
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    } else {
      setTimeout(() => {
        this.selectAssociate({ param: value });
      });
    }
    this.value = value;
    this.updateChanges();
  }
  ngOnInit(): void {
    this.parse = this.parse || {};
    monitor.on('setPropValueOf' + this.prop, (value) => {
      this.writeValue(value);
    });
  }

  setOptions(code: string) {
    if (!code) {
      return;
    }
    this.dictSrv.getDicListByDicCode(code).subscribe((res: any) => {
      if (res.status && res.data) {
        this.handleUrlData(res.data);
      }
    });
  }

  // èªå®ä¹çæ¥å£
  setUserDefineOptions(str, type) {
    if (!str || this.isInit) {
      return;
    }
    this.selectFetch(str, type, this.params);
    if (this.prop) {
      // æ³¨åäºä»¶
      monitor.on(this.prop + 'SelectFetch', this.selectFetch.bind(this, str, type));
    }
  }
  selectFetch(str, type, params) {
    params = { ...this.params, ...params };
    this.formSearchSrv.getUserdefineDictLists(str, params, type).subscribe((res) => {
      if (res.status && res.data) {
        this.handleUrlData(res.data);
        this.isInit = true;
      }
    });
  }
  // ç»ä»¶å³èåå¨ï¼æ§å¶å¯¹åºç»ä»¶
  selectAssociate(option: { [key: string]: any } = {}) {
    if (Array.isArray(this.associate)) {
      this.associate.forEach((i) => {
        this.setAssociateData(option, i);
      });
    }
  }
  setAssociateData(option: { [key: string]: any } = {}, associate) {
    const prop = associate.prop;
    const param: { [key: string]: any } = option.param;

    // è®¾ç½® prop å¯¹åºç»ä»¶ç value
    if (typeof associate === 'object') {
      monitor.emit('setPropValue', { currentProp: this.prop, targetValue: param, ...associate });
      if (associate.fetch) {
        // string, object
        const paramKeys = associate.fetch.params;
        if (paramKeys) {
          let params = {};
          if (typeof paramKeys === 'string') {
            params = { [paramKeys]: param };
          } else if (typeof paramKeys === 'object') {
            Object.keys(paramKeys).forEach((key) => {
              // {è½¬æ¢çkeyï¼[æ¹å¯¹è±¡çåæ°æ®çkey]}
              if (typeof param === 'object') {
                params[key] = param[paramKeys[key]];
              } else {
                params[key] = param;
              }
            });
          }
          monitor.emit(associate.prop + 'SelectFetch', params);
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.prop) {
      monitor.off(this.prop + 'SelectFetch');
      monitor.off('setPropValueOf' + this.prop);
    }
  }

  // å¤çæ¥å£æ°æ®
  handleUrlData(data) {
    // æ å½¢ç»æçè·åæ°æ®çè½¬å
    const parseLable = this.parse.label || this.dictConf.label;
    const parseValue = this.parse.code || this.dictConf.value;
    if (this.type === 'treeSelect') {
      data = this.handlerTreeData(data, 'title', 'key');
      // èå¨éæ©
    } else if (this.type === 'linkageSelect') {
      data = this.handlerTreeData(data, 'label', 'value');
    } else {
      data.forEach((i) => {
        i.label = i[parseLable] || i.projectName;
        i.value = i[parseValue] || i.projectCode;
      });
    }
    this.options = data;
  }

  // æ å½¢ç»æçå¤ç
  handlerTreeData(data, label, value) {
    if (isEmpty(data)) {
      return;
    }
    const newArr = data.map((t) => {
      t[label] = t[this.dictConf.label];
      t[value] = t[this.dictConf.value];
      if (!t.children || t.children.length === 0) {
        t.isLeaf = true;
        return t;
      }
      t.children = this.handlerTreeData(t.children, label, value);
      return t;
    });
    return newArr;
  }
  emitAssociate() {
    let value = this.value;
    const all = this.parse.all;
    const parseValue = this.parse.code || this.dictConf.value;
    if (all) {
      const tagertValue = [];
      if (Array.isArray(this.value)) {
        (this.options || []).forEach((i: any) => {
          if (value.includes(i[parseValue])) {
            tagertValue.push(i);
          }
        });
        this.selectAssociate({ param: this.value });
        this.selectValueChange.emit(tagertValue);
        this.valueChange.emit(tagertValue);
        return;
      } else {
        (this.options || []).forEach((i: any) => {
          if (i[parseValue] === value) {
            value = i;
          }
        });
      }
      this.selectAssociate({ param: this.value });
      this.valueChange.emit(value);
    } else {
      this.selectAssociate({ param: this.value });
      this.valueChange.emit(this.value);
    }
  }

  onSearch(val: string): void {
    const self = this;
    if (!self.searchParmas) {
      return;
    }
    clearTimeout(self.iTime);
    self.iTime = setTimeout(() => {
      self.isLoading = true;
      const parmas = this.params;
      Object.defineProperty(parmas, self.searchParmas, {
        value: val,
        enumerable: true,
      });
      self.addSearchSub(parmas);
    }, 400);
  }
  addSearchSub(parmas) {
    this.formSearchSrv.getUserdefineDictLists(this.urlCopy, parmas, this.requsetTypeIsForm).subscribe((res) => {
      if (res.status) {
        const datas = res.data;
        this.handleUrlData(datas);
        this.isLoading = false;
      }
    });
  }
  selectChange() {
    this.writeValue(this.value);
    this.updateChanges();
    this.emitAssociate();
  }
  handleSelectClick(evt) {
    if (this.type === 'select' || this.type === 'inputSelect') {
      if (Array.from(evt.target.classList).includes('ant-select-selection-selected-value')) {
        this.selectClick.emit(this.value);
      }
    } else {
      const label = evt.target.textContent;
      const parseLable = this.parse.label || this.dictConf.label;
      const parseValue = this.parse.code || this.dictConf.value;
      (this.options || []).forEach((i) => {
        if (i[parseLable] === label) {
          this.selectClick.emit(i[parseValue]);
        }
      });
    }
  }
  treeParentSelect($event: string[]): void {
    const checkData = this.treedom.getCheckedNodeList() || [];
    const halfCheckData = this.treedom.getHalfCheckedNodeList() || [];
    // ååææçcheckå¯¹è±¡
    let data = [];
    const checkDataReverse = []; // éä¸­çæ°æ®åæ
    const halfCheckDataIds = []; // åéçidéååæ
    for (let i = checkData.length - 1; i >= 0; i--) {
      checkDataReverse.push(checkData[i]);
    }

    if (halfCheckData && halfCheckData.length >= 1) {
      halfCheckData.forEach((i) => {
        halfCheckDataIds.unshift(i.key);
      });
    }

    // æ¥è¯¢ ç¬¬ä¸ä¸ªlevel===0çæ°æ®
    let hasOthersChildData = false;
    let hasOthersParentData = false;

    if (checkDataReverse.length >= 1) {
      for (const i of checkDataReverse || []) {
        if (i.level !== 0) {
          hasOthersChildData = true;
        }
        if (i.level === 0) {
          hasOthersParentData = true;
          data = i.key;
          break;
        }
      }
      // æç¶èç¹åå­èç¹åæ¶åå¨çæ¶å
      if (hasOthersParentData && hasOthersChildData) {
        for (const i of checkDataReverse || []) {
          if (i.level !== 0) {
            data = [i.key];
            break;
          }
        }
      }
      // åªæå­èç¹æ°æ®çæ¶å
      if (hasOthersChildData && !hasOthersParentData) {
        const duck = checkDataReverse.filter((par) => {
          return !!par.parentNode && par.parentNode.key === halfCheckDataIds[0];
        });
        (duck || []).forEach((i) => {
          data.push(i.key);
        });
      }
    }
    this.writeValue(this.value);
    this.updateChanges();
    this.valueChange.emit(data);
  }
}
